// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oJII4{background:var(--wpp-white-color);padding:20px;border-radius:12px;margin-bottom:16px}`, "",{"version":3,"sources":["webpack://./src/pages/ViewTask/ParentPdp/ParentPdp.module.scss"],"names":[],"mappings":"AACA,OACE,iCAAA,CACA,YAAA,CACA,kBAAA,CACA,kBAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.header {\n  background: var(--wpp-white-color);\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `oJII4`
};
export default ___CSS_LOADER_EXPORT___;
